// Placeholder cover palette shown before the backend's generated cover (§3.9) exists.
// Deliberately mirrors that stage's approach (deterministic color by hash(video_id))
// so the card doesn't visually "jump" once the real cover.png is ready.
const COVER_PALETTE = [
  "#2f6f64", // teal
  "#3d5a73", // steel blue
  "#6b5a8a", // muted plum
  "#7a5a3a", // warm brown
  "#5c6b3a", // olive
  "#8a4a52", // muted wine
  "#3f6b8a", // ocean blue
  "#8a7a3a", // ochre
];

function hashString(input: string): number {
  let h = 0;
  for (let i = 0; i < input.length; i++) {
    h = (h * 31 + input.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function coverColorFor(videoId: string): string {
  return COVER_PALETTE[hashString(videoId) % COVER_PALETTE.length];
}
